import React, { useEffect } from "react";
// A great library for fuzzy filtering/sorting items
import { matchSorter } from "match-sorter";
import Select from "../custom-select-list/CustomSelectList.component";
import { useTranslation } from "react-i18next";
import CustomDatePicker from "../custom-date-picker/CustomDatePicker.component";

// function DefaultColumnFilter({
//   column: { filterValue, id, preFilteredRows, setFilter, tableName },
// }) {
//   const count = preFilteredRows.length;

//   useEffect(()=> {
//     setFilter(JSON.parse(sessionStorage.getItem(tableName + "_" + id)))
//   }, [filterValue]);

//   const changeValue = (e) => {
//     setFilter(e.target.value || undefined);
//     sessionStorage.setItem(tableName + "_" + id, JSON.stringify(e.target.value));
//   }

//   return (
//     <input
//       className="form-control"
//       type="text"
//       defaultValue={JSON.parse(sessionStorage.getItem(tableName + "_" + id))}
//       onChange={changeValue}
//       placeholder={`Претрага`}
//     />
//   );
// }


function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, filteredRows, setFilter },
}) {
  const totalCount = preFilteredRows.length;
  const filterCount = filteredRows.length;
  
  return (
    <input
      className="form-control"
      type="text"
      value={filterValue || ""}
      //defaultValue={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
      placeholder={`Претрага`}
    />
  );
}

/**
 *@param rows - niz svih podataka
 *@param id - kolona po kojoj se vrsi pretraga
 *@param filterValue - podatak koji se pretrazuje
 *@return niz filtriranih podataka
 **/
function textFilterFunction(rows, id, filterValue) {
  return matchSorter(rows, filterValue, { keys: [(row) => row.original[id]] });
}

// Let the table remove the filter if the string is empty
textFilterFunction.autoRemove = (val) => !val;

const SelectColumnFilter = ({
  column: { filter, setFilter, filterValue, },
  array: array,
}) => {
  
  const {t} = useTranslation();

  // Render a multi-select box
  return (
    <div style={{ minWidth: "150px" }}>
      <Select
        options={filter.selectOptions}
        onChange={(e) => {
          setFilter(e.value);
        }}
        value={filter.selectOptions.filter(
          (x) => x.value === filterValue
        )}
        //defaultValue={filter?.selectOptions[0] || null}
      />
    </div>
  );
};

function dateBetweenFilterFn(rows, id, filterValue) {
  const value = filterValue ? new Date(filterValue) : undefined;
  if (value) {
    return rows.filter((r) => {
      const cellDate = new Date(r.values[id]);
      var date = cellDate.getDate();
      var month = cellDate.getMonth();
      var year = cellDate.getFullYear();

      return (
        date == value.getDate() &&
        month == value.getMonth() &&
        year == value.getFullYear()
      );
    });
  } else {
    return rows;
  }
}

function DateRangeColumnFilter({
  column: { filterValue, preFilteredRows, setFilter, id },
}) {
  const [min, max] = React.useMemo(() => {
    let min = preFilteredRows.length
      ? new Date(preFilteredRows[0].values[id])
      : new Date(0);
    let max = preFilteredRows.length
      ? new Date(preFilteredRows[0].values[id])
      : new Date(0);

    preFilteredRows.forEach((row) => {
      const rowDate = new Date(row.values[id]);

      min = rowDate <= min ? rowDate : min;
      max = rowDate >= max ? rowDate : max;
    });

    return [min, max];
  }, [id, preFilteredRows]);

  return (
    <div>
      <CustomDatePicker
        selected={filterValue}
        onChange={(date) => setFilter(date)}
        showMonthDropdown
        useShortMonthInDropdown
      />
    </div>
  );
}

export {
  DefaultColumnFilter,
  textFilterFunction,
  SelectColumnFilter,
  dateBetweenFilterFn,
  DateRangeColumnFilter,
};
